import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_DEFAULT_LEGAL_ENTITY_REQUEST = 'GET_DEFAULT_LEGAL_ENTITY_REQUEST';
export const GET_DEFAULT_LEGAL_ENTITY_SUCCESS = 'GET_DEFAULT_LEGAL_ENTITY_SUCCESS';
export const GET_DEFAULT_LEGAL_ENTITY_FAILURE = 'GET_DEFAULT_LEGAL_ENTITY_FAILURE';

function requestGetDefaultLegalEntity() {
  return {
    type: GET_DEFAULT_LEGAL_ENTITY_REQUEST,
    isGettingDefaultLegalEntity: true
  };
}

function receiveGetDefaultLegalEntity(defaultLegalEntity) {
  return {
    type: GET_DEFAULT_LEGAL_ENTITY_SUCCESS,
    isGettingDefaultLegalEntity: false,
    defaultLegalEntity: {
      legalEntity: defaultLegalEntity.legalEntity,
      count: defaultLegalEntity.count
    }
  };
}

function rejectGetDefaultLegalEntity() {
  return {
    type: GET_DEFAULT_LEGAL_ENTITY_FAILURE,
    isGettingDefaultLegalEntity: false
  };
}

export function getDefaultLegalEntity() {
  return (dispatch) => {
    dispatch(requestGetDefaultLegalEntity());
    const promise = () => ApiService
      .getDefaultLegalEntity()
      .then((response) => {
        dispatch(receiveGetDefaultLegalEntity(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetDefaultLegalEntity, true));
        }
      });

    return promise();
  };
}
